
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            form: {
                user_id: null,
                relationship: 'SPOUSE',
            },
            relatedClients: [],
            userRelationshipAddModal: false,
        }
    },
    async fetch () {
        if (this.uid) {
            const resp = await this.$try('getRelatedClients', this.uid, { spinner: false })
            if (resp?.clients) {
                const clients = resp?.clients.map((c) => {
                    c.relationship = resp?.spouse?.id === c.id ? 'Spouse' : resp?.relationships[c.id] || ''
                    return c
                })
                this.relatedClients = clients
                this.$store.commit('clients', clients)
            }
        }
    },
    computed: {
        ...mapGetters(['client', 'clients', 'uid', 'usersRelationshipTypes'])
    },
    methods: {
        async addRelatedClient () {
            const resp = await this.$try('addRelatedClient', this.uid, this.form)
            if (!resp?.error) {
                this.form.user_id = null
                this.form.relationship = 'SPOUSE'
                return this.$fetch()
            }
        },
        async confirmDeleteRelatedClient (id) {
            const value = await this.$bvModal.msgBoxConfirm('This will delete the automatic association of the clients, if applicable, this will also remove the Spouse field that you set in Salesforce', {
                title: 'Are you sure you want to remove the relation?',
                okVariant: 'danger',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                centered: true
            })
            if (value) {
                await this.$try('deleteRelatedClient', { id1: this.uid, id2: id })
                await this.$fetch()
            }
        }
    }
}
